import {App} from './App'
import {SearchEntrypoint, SearchEntrypointFuture} from './pages/Search'
import {registerDataRouterApp, registerNavigatorApp} from '@github-ui/react-core/register-app'
import {TransitionType} from '@github-ui/react-core/app-routing-types'
import {jsonRoute} from '@github-ui/react-core/json-route'
import {blackbirdSearchAppBuilder} from './config/app-builder'
import {blackbirdSearchRoute} from './routes/search-route'

export const routes = [
  // eslint-disable-next-line @github-ui/github-monorepo/prefer-data-router
  jsonRoute({path: '/search', Component: SearchEntrypoint, transitionType: TransitionType.TRANSITION_WHILE_FETCHING}),
  // eslint-disable-next-line @github-ui/github-monorepo/prefer-data-router
  jsonRoute({
    path: '/:user/:repo/search',
    Component: SearchEntrypoint,
    transitionType: TransitionType.TRANSITION_WHILE_FETCHING,
  }),
]

// eslint-disable-next-line @github-ui/github-monorepo/prefer-data-router
registerNavigatorApp('blackbird-search', () => ({
  App,
  routes,
}))

export const blackbirdSearchApp = blackbirdSearchAppBuilder.createDataRouterAppFromRoutes([
  {
    Component: App,
    children: [
      blackbirdSearchRoute.toRoute({
        Component: SearchEntrypointFuture,
      }),
    ],
  },
])
registerDataRouterApp(blackbirdSearchApp)
